import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import api from "../../api/api";
import { toast } from "react-toastify";

export const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [sending, setSending] = useState(false);
  const navigate = useNavigate();

  const handleSend = async (e) => {
    e.preventDefault();
    if (!email) return toast.warn("Please enter your email address");

    try {
      setSending(true);
      await api.auth.sendResetOtp(email);
      // go to OTP page
      navigate(`/reset-password/otp?email=${encodeURIComponent(email)}&flow=reset`);
    } catch (err) {
      console.warn("Send reset OTP failed:", err?.status, err?.message);
      toast.warn(err?.data?.message || "Failed to send reset code. Please try again.");
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="min-h-screen grid place-items-center bg-[#fff8e1]">
      <div className="w-[412px] [font-family:'Nunito',Helvetica] text-[#5d4037]">
   
        <div className="w-full flex items-center justify-center mt-6">
          <button
            type="button"
            aria-label="Go back"
            onClick={() => navigate(-1)}
            className="w-10 h-10 rounded-full bg-[#ccb357] grid place-items-center"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#5d4037" strokeWidth="2">
              <path d="M15 18l-6-6 6-6" />
            </svg>
          </button>
        </div>

        <h1 className="mt-6 text-center font-bold text-2xl leading-9">Forget password</h1>
        <p className="mt-2 w-[358px] mx-auto text-center font-medium text-base leading-6">
          It happens to the best of us! Enter your email to reset
          <br /> your password.
        </p>

        <form onSubmit={handleSend} className="mt-10">
     
          <div className="w-[378px] mx-auto">
            <label className="block text-base font-semibold mb-3">Email address</label>
            <input
              type="email"
              placeholder="Email address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full h-[56px] bg-[#fff8e1] rounded-[18px] border border-[#5d4037] px-[17px] text-[#7a6f5c] text-base leading-[22px] outline-none"
            />
          </div>

          <div className="w-[378px] mx-auto">
            <button
              type="submit"
              disabled={sending}
              className={`mt-12 w-full h-[60px] rounded-[50px] font-bold text-base text-[#5d4037] transition-opacity ${
                sending ? "bg-[#d9c48c] cursor-not-allowed" : "bg-[#f7c945] hover:opacity-90"
              }`}
            >
              {sending ? "Sending..." : "Send code"}
            </button>
          </div>

          
          <p className="w-full text-center mt-6 text-base">
            <span className="font-medium text-[#a99451]">Haven't registered yet?</span>
            <span className="font-medium text-[#1f233673]"> </span>
            <Link to="/signup" className="font-semibold text-[#663114] underline hover:opacity-80">
              Register
            </Link>
          </p>
        </form>
      </div>
    </div>
  );
};
